<template>
  <div style="position: relative">
    <div class="title">
      <span class="vertical-bar fn18 fnM" style="line-height: 32px">高级搜索（{{com.config.moduleName}}）</span>
      <div class="table-btns">
        <el-button type="primary" @click="jsonEditor.show=true">
          {{jsonEditor.readOnly?"查看JSON代码":"编辑JSON代码"}}
        </el-button>
      </div>
    </div>
    <el-dialog
      title="高级搜索"
      class="source_dialog code_source_dialog"
      :visible.sync="jsonEditor.show"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @open="onJsonEditorDialogOpen"
      @closed="onJsonEditorDialogClosed"
    >
      <div class="editor">
        <CodeMirrorEditor ref="jsonEditor" v-model="jsonEditor.data" :readOnly="jsonEditor.readOnly" @save="onJsonEditorDialogSave"></CodeMirrorEditor>
      </div>
      <div class="footer" v-if="!jsonEditor.readOnly">
        <el-button @click="onJsonEditorDialogCancel">取消</el-button>
        <el-button type="primary" @click="onJsonEditorDialogSave(jsonEditor.data)">保存</el-button>
      </div>
    </el-dialog>
    <el-table :data="data" stripe style="width: 100%" ref="dt" row-key="searchItemName">
      <el-table-column type="index" label="序号" width="80" fixed="left"></el-table-column>
      <el-table-column prop="searchItemDisplayName" label="组件显示名称">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit'">
            <el-input v-model="scope.row.searchItemDisplayName" placeholder="请输入内容"></el-input>
          </span>
          <span v-else>
            {{scope.row.searchItemDisplayName}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="searchItemType" label="组件类型" width="180" :formatter="formatter_searchItemType"></el-table-column>
      <el-table-column prop="searchItemName" label="对应字段CODE码" ></el-table-column>
      <el-table-column prop="hidden" label="默认隐藏" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit'">
            <el-select v-model="scope.row.hidden" placeholder="请选择" @change="onHiddenChange(scope.row)">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </span>
          <span v-else>
            {{formatter_hidden(scope.row)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="moreFlag" label="置于更多" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit'">
            <el-select v-model="scope.row.moreFlag" placeholder="请选择" @change="onMoreFlagChange(scope.row)">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </span>
          <span v-else>
            {{formatter_moreFlag(scope.row)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="updateIndex" label="显示顺序" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.sys_mode==='edit'">
            <el-input-number v-model="scope.row.sys_order" controls-position="right" :min="1"></el-input-number>
          </span>
          <span v-else>
            {{scope.row.sys_order}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.sys_mode==='edit'">
            <el-button type="text" class="btn__text--no-padding" @click="onRowSave(scope)">保存</el-button>
            <el-button type="text" class="btn__text--no-padding grey" @click="restoreRowState(scope.$index)">取消</el-button>
          </template>
          <template v-else>
            <el-button type="text" class="btn__text--no-padding" @click="onRowEdit(scope)">编辑</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="suspend.synchronizing" class="mask">
      <span class="text"><i class="el-icon-loading"></i></span>
    </div>
  </div>
</template>

<script>
import CodeMirrorEditor from "@/components/common/CodeMirror";

export default {
  name: "Search",
  components: {CodeMirrorEditor},
  inject: ["saveConfig", "getResourceConfigCopy"],
  props: {
    com: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: [],
      suspend: {
        synchronizing: false,
        method: "",
        effectRowIndex: NaN
      },
      jsonEditor: {
        show: false,
        data: "",
        readOnly: false
      }
    };
  },
  watch: {
    com(newValue, oldValue) {
      this.tableDatasourceConstructor();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableDatasourceConstructor();
    });
  },

  methods: {
    tableDatasourceConstructor() {
      this.data = JSON.parse(JSON.stringify(this.com.config.schema));
      this.data.forEach((row, index) => {
        this.$set(row, "sys_mode", "view");
        this.$set(row, "sys_order", index + 1);
      });
    },

    formatter_hidden(row) {
      return row.hidden ? "是" : "否";
    },
    formatter_moreFlag(row) {
      return row.moreFlag ? "是" : "否";
    },
    formatter_searchItemType(row) {
      switch (row.searchItemType) {
        case 1: {
          return "文本输入";
        }
        case 2: {
          return "数值输入";
        }
        case 3: {
          return "下拉选择";
        }
        case 4: {
          return "下拉选择（分页加载）";
        }
        case 5: {
          return "下拉选择（树状结构）";
        }
        case 6: {
          return "日期选择";
        }
        case 7: {
          return "日期范围";
        }
        case 8: {
          return "数值范围";
        }
      }
    },

    onHiddenChange(row) {
      if (!row.hidden) {
        row.moreFlag = true;
      }
    },
    onMoreFlagChange(row) {
      if (!row.moreFlag && !row.hidden) {
        row.moreFlag = true;
        this.$message("默认显示的搜索条件必须置于更多中");
      }
    },

    onRowEdit(scope) {
      for (let i = 0; i < this.data.length; i++) {
        this.restoreRowState(i);
      }

      this.$set(this.data[scope.$index], "sys_backup", JSON.stringify(this.data[scope.$index]));
      this.$set(this.data[scope.$index], "sys_mode", "edit");
    },
    onRowSave(scope) {
      if (scope.row.searchItemDisplayName.trim() === "") {
        this.$message.error("组件显示名称为必填");
        return;
      }

      /*for (let i = 0; i < this.data.length; i++) {
        if (i === scope.$index) {
          continue
        } else {
          if (scope.row.updateIndex === this.data[i].updateIndex) {
            this.$message.error('显示顺序值重复');
            return;
          }
        }
      }*/

      this.suspend.synchronizing = true;
      this.suspend.method = "row";
      this.suspend.effectRowIndex = scope.$index;

      const dataCopy = JSON.parse(JSON.stringify(this.data));
      dataCopy.sort((a, b) => a.sys_order - b.sys_order);
      dataCopy.forEach(row => {
        delete row.sys_mode;
        delete row.sys_backup;
        delete row.sys_order;
      });
      const resourceConfigCopy = this.getResourceConfigCopy();
      resourceConfigCopy.componentAttributesMap[this.com.id].schema = dataCopy;
      this.saveConfig({
        content: JSON.stringify(resourceConfigCopy),
        succCallback: this.saveSuccCallback,
        failedCallback: this.saveFailedCallback
      });
    },
    restoreRowState(index) {
      const theRow = this.data[index];

      if (!theRow.sys_backup) {
        return;
      }

      const theRowBackUp = JSON.parse(theRow.sys_backup);
      Object.keys(theRowBackUp).forEach(key => {
        theRow[key] = theRowBackUp[key];
      });
      delete theRow.sys_backup;
    },

    saveSuccCallback() {
      switch (this.suspend.method) {
        case "row": {
          const theRow = this.data[this.suspend.effectRowIndex];
          delete theRow.sys_backup;
          this.$set(theRow, "sys_mode", "view");
          break;
        }
        case "json": {
          this.tableDatasourceConstructor();
          this.jsonEditor.show = false;
          break;
        }
      }

      this.suspend.synchronizing = false;
      this.suspend.method = "";
      this.suspend.effectRowIndex = NaN;
      this.$message.success("已保存");
    },
    saveFailedCallback(reason) {
      switch (this.suspend.method) {
        case "row": {
          break;
        }
        case "json": {
          break;
        }
      }

      this.suspend.synchronizing = false;
      this.suspend.method = "";
      this.suspend.effectRowIndex = NaN;
      this.$message.error(`保存失败:${reason}`);
    },

    onJsonEditorDialogOpen(){
      for (let i = 0; i < this.data.length; i++) {
        this.restoreRowState(i);
      }

      this.jsonEditor.data = JSON.stringify(this.com.config.schema);
    },
    onJsonEditorDialogClosed(){
      this.jsonEditor.data = "";
    },
    onJsonEditorDialogSave(val){
      this.suspend.synchronizing = true;
      this.suspend.method = "json";
      this.suspend.effectRowIndex = NaN;

      const dataCopy = JSON.parse(this.jsonEditor.data);
      const resourceConfigCopy = this.getResourceConfigCopy();
      resourceConfigCopy.componentAttributesMap[this.com.id].schema = dataCopy;
      this.saveConfig({
        content: JSON.stringify(resourceConfigCopy),
        succCallback: this.saveSuccCallback,
        failedCallback: this.saveFailedCallback
      });
    },
    onJsonEditorDialogCancel() {
      this.jsonEditor.show = false;
    }
  }
};
</script>

<style scoped lang="scss">
  @import "style";
</style>
